import { combineReducers } from "redux";

import tspayConfig from "./tspay-config";
import tspayOnboarding from "./tspay-connect";
import tspayResend from "./tspay-resend-confirm";

export default combineReducers({ tspayConfig, tspayOnboarding, tspayResend });
